// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error TODO: type or globally ignore react-components
import { FieldError } from '@checkout/react-components';

// Internal modules
import { buildTermsUrl, getContent } from '@/lib';
import { Checkbox, Link } from '@/components/Common';
import { errorStyleOverrides } from './styles';
import { logLinkClick } from '../../../OnboardTerms/utils';

interface RightOfWithdrawalProps {
  changeHandler: (
    e: React.ChangeEvent<HTMLInputElement>,
    newValue: string | boolean,
    oldValue: string | boolean,
    metadata: any,
  ) => void;
}

const RightOfWithdrawal = ({
  changeHandler,
}: RightOfWithdrawalProps): React.ReactElement => {
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const rightOfWithdrawal = useStoreState(({ form }) => form.rightOfWithdrawal);
  const hasError = Boolean(rightOfWithdrawal?.displayError);
  const checkboxContent = getContent('rightOfWithdrawal.legalAgreement', {
    rightOfWithdrawalLink: (
      <Link
        href={buildTermsUrl({ useFunction: 'rightOfWithdrawal' })}
        onClick={() =>
          logLinkClick('right-of-withdrawal', 'ua/useragreement-full')
        }
        testId="right-of-withdrawal"
        text={getContent('compliance.rightOfWithdrawal')}
      />
    ),
  });

  // We won't render a different version for Streamline because we need
  // a separate checkbox for this

  return (
    <>
      <Checkbox
        aria-describedby={hasError ? 'rightOfWithdrawal-error' : null}
        aria-invalid={hasError}
        changeHandler={changeHandler}
        checked={rightOfWithdrawal?.value}
        disabled={isFormSubmitting}
        id="rightOfWithdrawal"
        testID="rightOfWithdrawalCheckbox"
        label={checkboxContent}
        name="rightOfWithdrawal"
        required={true}
        isTermsCheckbox
        {...rightOfWithdrawal}
      />
      {hasError && (
        <FieldError
          id="right-of-withdrawal-error"
          styleOverrides={errorStyleOverrides}
          data-testid="rightOfWithdrawalError"
        >
          {getContent('fieldErrors.rightOfWithdrawal.valueMissing')}
        </FieldError>
      )}
    </>
  );
};

export { RightOfWithdrawal };
